"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeColor = void 0;
var ThemeColor;
(function (ThemeColor) {
    ThemeColor["DARK"] = "_dark";
    ThemeColor["LIGHT"] = "_light";
})(ThemeColor = exports.ThemeColor || (exports.ThemeColor = {}));
//# sourceMappingURL=FeedbackProps.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/panels/Feedback/FeedbackProps.js
// module id = 255
// module chunks = 8